import React, { useState } from "react";
import "../../style/textbox.css";

export default function TextBoxForm() {

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    address: "",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form Submitted\n\n" + JSON.stringify(formData, null, 2));
  };

  return (
    <form
      id="TextForm"
      className="form-signin"
      onSubmit={handleSubmit}
      noValidate
    >

      <h1 className="form-title">Text Box</h1>

      <div className="form-row">

        <label htmlFor="fullname">Full Name :</label>

        <input
          id="fullname"
          name="fullname"
          type="text"
          placeholder="Full Name"
          value={formData.fullname}
          onChange={handleChange}
        />

      </div>

      <div className="form-row">

        <label htmlFor="email">Email :</label>

        <input
          id="email"
          name="email"
          type="email"
          placeholder="name@example.com"
          value={formData.email}
          onChange={handleChange}
        />

      </div>

      <div className="form-row">

        <label htmlFor="address">Current Address :</label>

        <textarea
          id="address"
          name="address"
          placeholder="Current Address"
          value={formData.address}
          onChange={handleChange}
        />

      </div>

      <div className="form-row">

        <label htmlFor="password">Password :</label>

        <input
          id="password"
          name="password"
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
        />

      </div>

      <div className="form-button">

        <button type="submit">
          Submit
        </button>

      </div>

    </form>
  );
}